import { Dropdown } from "react-bootstrap";
import styled from "styled-components";
import { Colors } from "../../shared/colors/colors";

export const TableContainer = styled.div<{ marginBottom?: number }>`
  width: auto;
  border-radius: 8px 8px 0 0;
  overflow: auto;
  margin-bottom: ${(props) => props.marginBottom || 20}px;
  position: relative;

  .table-wrapper {
    width: 100%;
    overflow-x: auto;
    overflow-y: visible;
    position: relative;
  }
`;

export const TableModalContainer = styled.div`
  width: 60vw;
  border-radius: 8px 8px 0 0;
  overflow: auto;
  margin-bottom: 20px;
  position: relative;

  .table-wrapper {
    width: 100%;
    overflow-x: auto;
    overflow-y: visible;
    position: relative;
  }
`;

export const Table = styled.table<{ firstColSmall?: boolean }>`
  width: 100%;
  border-collapse: collapse;
  font-size: 1rem;
  text-align: left;
  overflow: visible;
    margin-top: 20px;

  table-layout: auto;

  ${({ firstColSmall }) =>
    firstColSmall &&
    `
    th:first-child,
    td:first-child {
      width: 1%;
      white-space: nowrap;
      text-align: center;
    }
  `}
`;

export const TableHead = styled.thead`
  background-color: ${Colors.primary};
  height: auto;
  margin-botton: 20px;
`;

export const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: ${Colors.backgroundColorTable};
  }

  &.total-row {
    background-color: ${Colors.backgroundColorTable};
    font-weight: bold;

    td {
      border-top: 2px solid ${Colors.primary};
      font-size: 15px;
      color: ${Colors.primary};
    }
  }
`;

export const TableHeader = styled.th`
  padding: 0.75rem 1rem;
  font-weight: 700;
  font-size: 16px;
  color: ${Colors.white};
  text-align: start;
  align-items: center;
`;

export const TableData = styled.td<{ fontColor?: string }>`
  padding: 0.75rem 1rem;
  border: 1px solid ${Colors.borderMenu};
  font-weight: 400;
  font-size: 14px;
  color: ${(props) => props.fontColor ? props.fontColor : Colors.fontColorTable};
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ButtonAction = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

export const MenuTable = styled(Dropdown.Menu) <{ isLastRows?: boolean }>`
  position: absolute;
  right: 95%;
  ${(props) => (props.isLastRows ? "bottom: calc(100% - 45px);" : "top: 0;")}
  z-index: 999;
  max-width: 300px;
  min-width: 200px;
  padding: 0;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-height: 300px;
  overflow-y: auto;
  transform-origin: ${(props) =>
    props.isLastRows ? "bottom right" : "top right"};
`;

export const MenuTableItem = styled(Dropdown.Item)`
  padding: 10px 15px;
  font-size: 14px;
  color: ${Colors.primary};

  &:hover {
    background-color: #f8f9fa;
  }
  &:active {
    color:${Colors.primary};
  }  
`;

export const MenuTableDivider = styled(Dropdown.Divider)`
  margin: 0;
`;
